// This file contains dependencies on environment variables that are read from
// `.env` file from the project root. Instruction to create this file are given in `.env.sample` file.
// If you haven't created `.env` file yet, we suggest to create it before trying to run this app.

let urlRoot = 'https://www.addy.co';
let apiRoot = 'https://api-qa.addy.co/api/v1';
let wwwUrl = 'http://localhost:3000';
let heapProductID = 2563703480;
let salesforceWebhook = process.env.REACT_APP_SALESFORCE_ZAPIER_HOOK;
let sentryDSN = process.env.REACT_APP_SENTRY_DSN;
let tracesSampleRate = 1.0;

const mapboxAccessToken = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;
const authTimeout = 24 * 60 * 60 * 1000;

let environment = 'local';
if (process.env.REACT_APP_ENVIRONMENT == 'production') {
  environment = 'production';
} else {
  environment = process.env.REACT_APP_ENVIRONMENT;
}

switch (environment) {
  case 'local':
    urlRoot = 'http://localhost:3000';
    apiRoot = 'https://api-qa.addy.co/api/v1';
    tracesSampleRate = 0.1;
    break;

  case 'staging':
    urlRoot = 'https://storefront-qa.addy.co';
    apiRoot = 'https://api-qa.addy.co/api/v1';
    wwwUrl =
      'http://abdm-np.groundtruth.com.s3-website-us-east-1.amazonaws.com';
    tracesSampleRate = 1.0;
    break;

  case 'production':
    urlRoot = 'https://shop.addy.co';
    apiRoot = 'https://api.addy.co/api/v1';
    wwwUrl = 'http://abdm.groundtruth.com';
    tracesSampleRate = 0.2;
    heapProductID = 2051101396;
    break;
}

const config = {
  apiUrl: apiRoot,
  urlRoot: urlRoot,
  mapboxAccessToken: mapboxAccessToken,
  salesforceWebhook: salesforceWebhook,
  sentryDSN: sentryDSN,
  tracesSampleRate: tracesSampleRate,
  wwwUrl: wwwUrl,
  authTimeout: authTimeout,
  environment: environment,
  heapProductID: heapProductID,
};

export default config;
